import { email as emailSchema, phone as phoneSchema } from '@glade-ai/ui';
import z from 'zod';

import { password as passwordSchema } from './password';

/** Zod schema for user sign-up form validation. */
export const signUpSchema = z.object({
  country: z.string().optional(),
  email: emailSchema(),
  name: z.string().min(1, { message: 'Please enter your name.' }),
  password: passwordSchema(true),
  phone: phoneSchema(),
});

export type SignUpSchema = z.infer<typeof signUpSchema>;
